import gql from 'graphql-tag';

export const updateCompanyMutation = gql`
    mutation  updateCompany($companyInput: CompanyInput!) {
        updateCompany(companyInput: $companyInput)
    }`;
